import axios from 'axios';


const isProduction = process.env.NODE_ENV === "production";

let BASE_URL = "";

if( isProduction ) {
    BASE_URL = 'https://app-constancias.herokuapp.com/api/v1'
} else {
    BASE_URL = 'http://localhost:8080/api/v1'
}

export default axios.create({ baseURL: BASE_URL })